import { Avatar, Button, Stack, Typography } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ISelectedCategory {
  selectedCategory: IBurgerMenuItem;
  itemNavigationHandler: Function;
}

export const SelectedCategory = ({
  selectedCategory,
  itemNavigationHandler,
}: ISelectedCategory) => {
  return (
    <>
      <Stack
        sx={{
          flexDirection: 'row',
          mt: '16px',
          p: '16px 20px',
          width: 'calc(100% + 33px)',
          justifyContent: 'flex-start',
          gap: '10px',
          bgcolor: 'primary.shade_100',
          borderRadius: '34px 0px 0px 34px',
        }}
      >
        <Avatar
          sx={{ width: '24px', height: '24px' }}
          src={selectedCategory.mobileIconUrl}
          alt=''
        />
        <Typography variant='body3' color='initial'>
          {selectedCategory.description}
        </Typography>
      </Stack>
      <Stack mt={'24px'}>
        {selectedCategory?.subItems?.map(
          (subItem: IBurgerMenuItem, index: number) => (
            <Button
              key={index}
              sx={{ width: 'fit-content' }}
              onClick={() => itemNavigationHandler(subItem)}
              onKeyDown={onEnterOrEscapeKeyDown}
            >
              <Typography color={'initial'} variant='body3'>
                {subItem.description}
              </Typography>
            </Button>
          )
        )}
      </Stack>
    </>
  );
};
